export class UnitConverter{

    constructor(){

    }

    meteresToKm(meteres:number){
        return meteres / 1000;
    }

    convertTime(time:number,from,to) {

        switch (to) {
            case "min": {
                if (from == "sec") {

                    return this.secondToMinute(time);
                }
                if (from == "hrs") {
                    return this.hourToMinute(time);
                }
                break;
            }
            case "sec": {
                if (from == "min") {

                    return this.minuteToSecond(time);
                }
                if (from == "hrs") {
                    return this.hourToSecond(time);
                }
                break;
            }
            case "hrs": {
                if (from == "sec") {

                    return this.secondToHours(time);
                }
                if (from == "min") {
                    return this.minuteToHours(time);
                }
                break;
            }
        }
    }

    minuteToSecond(minutes) {
        return minutes * 60
    }

    minuteToHours(minutes){
        return minutes / 60;
    }

    hourToSecond(hours) {
        return (hours * 60) * 60;
    }
    secondToHours(seconds) {
        
        return (seconds / (60 * 60));
    }

    hourToMinute(hours) {
        return (hours * 60);
    }
    secondToMinute(seconds) {
        return seconds / 60;
    }


    secondsToFormattedTime(time:number,noHours = false,noUnints = false){
        
        var mins = this.secondToMinute(time);
        if(mins > 60 && !noHours){
            var hours = this.minuteToHours(mins);
            var decimalPortion = hours % 1;
            if(!noUnints){
                return Math.floor(hours) + " Hour(s) " + Math.floor(decimalPortion * 60) + " Minutes(s)"
            }else{
                return Math.floor(hours) + "";
            }

        }else{
            if(!noUnints){
                return Math.floor(mins) + " Minute(s)";
            }else{
                return Math.floor(mins) + "";
            }

        }
    }

    secondsToFormattedTimeShort(time:number,noHours = false,noUnints = false){
        
        var mins = this.secondToMinute(time);
        if(mins > 60 && !noHours){
            var hours = this.minuteToHours(mins);
            var decimalPortion = hours % 1;
            if(!noUnints){
                return Math.floor(hours) + "h " + Math.floor(decimalPortion * 60) + "m"
            }else{
                return Math.floor(hours) + "";
            }

        }else{
            if(!noUnints){
                return Math.floor(mins) + "m";
            }else{
                return Math.floor(mins) + "";
            }

        }
    }

    secondsToFormattedHourMinSecond(time: number): string {
  // Convert milliseconds → seconds if needed
  const totalSeconds = time > 10000 ? time / 1000 : time;

  if (isNaN(totalSeconds) || totalSeconds < 0) {
    return '00:00:00';
  }

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  return `${hours.toString().padStart(2, '0')}:` +
         `${minutes.toString().padStart(2, '0')}:` +
         `${seconds.toString().padStart(2, '0')}`;
}
}


// WEBPACK FOOTER //
// ./src/app/utilities/unit-converter/UnitConverter.ts